import {
  AfterViewInit,
  DestroyRef,
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { fromEvent, withLatestFrom, zip } from 'rxjs';

@Directive({
    selector: '[prSwipe]',
    standalone: false
})
export class EaSwipeDirective implements AfterViewInit {
  @Output() onSwipeLeft = new EventEmitter();
  @Output() onSwipeRight = new EventEmitter();
  @Input() threshold = 30;

  private destroyRef = inject(DestroyRef);

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    zip(
      fromEvent<TouchEvent>(document, 'touchstart'),
      fromEvent<TouchEvent>(document, 'touchend').pipe(
        withLatestFrom(fromEvent<TouchEvent>(document, 'touchmove')),
      ),
    )
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(([touchdown, [_, touchmove]]) => {
        let target = touchdown.target as HTMLElement;

        let touchOccuredOnDirective: HTMLElement | null = null;

        if (target.nodeType === 1) {
          // Walk up the DOM tree to find the closest element that matches this directive
          while (target && target !== this.el.nativeElement) {
            if (target === this.el.nativeElement) {
              touchOccuredOnDirective = target;
              break;
            }
            target = target.parentElement;
          }
        }
        if (touchOccuredOnDirective)
          this.compareDistance(
            touchdown.touches[0].clientX,
            touchmove.touches[0].clientX,
          );
      });
  }

  compareDistance(startX, endX) {
    const xDiff = startX - endX;
    if (Math.abs(xDiff) > (this.threshold / 100) * document.body.clientWidth) {
      if (xDiff > 0) {
        this.onSwipeRight.emit('right');
      } else {
        this.onSwipeLeft.emit('left');
      }
    }
  }
}
